<template>
  <base-item-group :item="item" text subGroup />
</template>

<script>
export default {
  name: 'DashboardMenuItemSubGroup',

  props: {
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: [],
      }),
    },
  },
};
</script>
